import * as payment     from './payment';

export default ({
  payment
});